import React, { useState, useEffect, useContext } from 'react'
import { RemoveCon } from '../../styles'
import { AllStarContext } from '../../../../Context'
import { useAuthContext } from '../../../../Context/AuthContext/AuthContext'
import {
  formatNumberOrdinal,
  getPlayerExperience,
  getTeamIc,
  logEvent,
  getUserId,
} from '../../../../Utils'
import { PlayerCol } from '../../../AllStarGame/styles'
import { Img } from '../../../../Components/Image/Img'
import { colors } from '../../../../Components/consts'
import { CirclePlus } from '../../../../Components/Icons'
import { ANALYTICS_TAGS } from '../../../../Constant'
import { type PlayersOnTeam } from '../../../../Api'

type AllStarPlayerParams = {
  player: PlayersOnTeam
  isSelected: (player: PlayersOnTeam) => boolean
}

export const PlayerItem: React.FC<React.PropsWithChildren<AllStarPlayerParams>> = ({
  player,
  isSelected,
}) => {
  const { selectedPlayers, selectPlayer, removePlayer } = useContext(AllStarContext)!
  const authContext = useAuthContext()
  const [playerSelected, setPlayerSelected] = useState<boolean>(isSelected(player))
  const exp = getPlayerExperience(player)

  useEffect(() => {
    const selectionStatus = isSelected(player)
    setPlayerSelected(selectionStatus)
  }, [])

  useEffect(() => {
    const selectionStatus = isSelected(player)
    setPlayerSelected(selectionStatus)
  }, [playerSelected, selectedPlayers])

  const onSelectPlayer = () => {
    const userId = getUserId(authContext)

    if (playerSelected) {
      const removed = removePlayer(player)
      if (removed) {
        logEvent(ANALYTICS_TAGS.allstar_player_remove, {
          playerId: player.officialId,
          playerName: `${player.firstName} ${player.lastName}`,
          position: player.currentTeam?.position,
          conference: player.currentTeam?.conference,
          team: player.currentTeam?.fullName,
          totalRemaining: selectedPlayers.length - 1,
          userId: userId || 'anonymous',
        })
        setPlayerSelected(!playerSelected)
      } else {
        logEvent(ANALYTICS_TAGS.allstar_vote_status_error, {
          context: 'player_removal_failed',
          playerId: player.officialId,
          userId: userId || 'anonymous',
        })
      }
    } else {
      const added = selectPlayer(player)
      if (added) {
        logEvent(ANALYTICS_TAGS.allstar_player_select, {
          playerId: player.officialId,
          playerName: `${player.firstName} ${player.lastName}`,
          position: player.currentTeam?.position,
          conference: player.currentTeam?.conference,
          team: player.currentTeam?.fullName,
          totalSelected: selectedPlayers.length + 1,
          userId: userId || 'anonymous',
        })
        setPlayerSelected(!playerSelected)
      } else {
        logEvent(ANALYTICS_TAGS.allstar_vote_failure, {
          context: 'player_selection_failed',
          playerId: player.officialId,
          reason: 'validation_failed',
          userId: userId || 'anonymous',
        })
      }
    }
  }

  return (
    <PlayerCol key={player.officialId} isSelected={playerSelected}>
      <div className="topCon">
        <div className="profileCon">
          <Img className="profile" src={player.profileUrl} alt="player profile image" />
          {player?.currentTeam?.fullName && (
            <Img
              className="teamLogo"
              src={getTeamIc(player.currentTeam.fullName)}
              alt={`${player.currentTeam.fullName} logo`}
            />
          )}
        </div>
        {!playerSelected && (
          <div className="selectCon" onClick={() => onSelectPlayer()}>
            <CirclePlus fill={colors.white} width={30} height={30} />
          </div>
        )}
        {playerSelected && (
          <RemoveCon onClick={() => onSelectPlayer()}>
            <div className="sign">-</div>
          </RemoveCon>
        )}
      </div>
      <div className="title">
        {player.firstName ? `${player.firstName.charAt(0)}. ` : ''}
        {player.lastName}
      </div>
      <p className="college">{formatNumberOrdinal(exp)} year</p>
      <p className="college">{player.college}</p>
      <div className="points">{player?.stats?.statsSummary || ''}</div>
    </PlayerCol>
  )
}
